if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * @param {MouseEvent | KeyboardEvent} event - Click or keydown event
     */
    toggle(event) {
      event.preventDefault();
      this.classList.toggle('is-active');
      this.head.setAttribute(
        'aria-expanded',
        this.classList.contains('is-active') ? 'true' : 'false',
      );
    }

    /**
     * @param {KeyboardEvent} event - Keydown event
     */
    handleKeydown(event) {
      if (event.code?.toUpperCase() !== 'SPACE') return;
      this.toggle(event);
    }

    connectedCallback() {
      /** @type {HTMLElement | null} */
      this.head = this.querySelector('.js-accordion-head');

      if (this.head) {
        this.head.addEventListener('click', this.toggle.bind(this));
        this.head.addEventListener('keydown', this.handleKeydown.bind(this));
      }
    }
  }
  customElements.define('accordion-item', AccordionItem);
}
